import styled from '@emotion/styled';
import { ifProp } from 'styled-tools';
import ChevrunUp from '~/icons/chevron-down.svg';
import imageStyle from '~/shared/components/Image/Image.module.scss';
import { breakpoints } from '~/theme/breakpoints';
import { StyledResetButton } from '~/shared/components';

export const StyledVariantList = styled.ul(() => ({
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(48px, 48px))',
    gridGap: `8px`,
    alignContent: 'center',
    justifyContent: 'center',
    padding: `0`,
}));

export const StyledAlertText = styled.p(({ theme }) => ({
    fontSize: theme.fontSizes.xs,
    lineHeight: theme.lineHeights.base,
    textAlign: 'left',
    strong: {
        fontWeight: theme.fontWeights.bold,
    },
}));

export const StyledVariantListItem = styled.li<{ isDisabled?: boolean; isActive?: boolean }>(
    ({ theme }) => ({
        border: `1px solid ${theme.colors.brownLight}`,
        height: theme.metrics.medium,
        width: theme.metrics.medium,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '5px',
        cursor: 'pointer',
        position: 'relative',
        padding: 0,
        background: theme.colors.productImageBackround,

        img: {
            mixBlendMode: 'multiply',
        },

        [`.${imageStyle.imageWrapper}`]: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 0,
        },
        [breakpoints.xs]: {
            [`.${imageStyle.imageWrapper}`]: {
                padding: 0,
            },
        },
    }),
    ifProp('isActive', ({ theme }) => ({
        border: `1px solid ${theme.colors.black}`,
    })),
);

export const DropdownWrapper = styled.div<{ isSelectedOrderable: boolean; isOpen: boolean }>(
    ({ isSelectedOrderable, isOpen }) => ({
        textAlign: 'left',

        [`${StyledArrowDown}`]: {
            transform: `rotateX(${isOpen ? '180deg' : '0'})`,
        },

        '.is-selected': {
            opacity: isSelectedOrderable ? 1 : 0.5,
        },
    }),
);

export const DropdownLabel = styled.label(({ theme }) => ({
    display: 'inline-flex',
    background: theme.colors.white,
    padding: theme.space[1],
    position: 'relative',
    top: '10px',
    left: theme.space[3],
    textTransform: 'uppercase',
    fontSize: '10px',
}));

export const StyledArrowDown = styled(ChevrunUp)(() => ({
    transform: `rotateX(${'0deg'})`,
    transition: 'transform 0.15s ease-in',
}));

export const StyledVariantDropdown = styled(StyledResetButton)(({ theme }) => ({
    ...theme.mixins.useTextStyle('bodySmall'),
    padding: '15px',
    border: `1px solid ${theme.colors.black}`,
    display: 'flex',
    justifyContent: 'space-between',
    borderRadius: '5px',
    width: '100%',
    ':focus-visible': {
        boxShadow: theme.shadows.accessibility,
    },
}));

export const StyledVariantDropdownItem = styled(StyledResetButton)(({ theme }) => ({
    ...theme.mixins.useTextStyle('bodySmall'),
    display: 'block',
    width: '100%',
    textAlign: 'left',
    padding: theme.space[1],
    paddingLeft: '16px',
    '&.disabled': {
        opacity: 0.5,
    },
    ':focus-visible': {
        boxShadow: theme.shadows.accessibility,
    },
}));
